/**
 * App 主线包列表页面
 */

import React from 'react'
import Dialog from '@tencent/spaui-dialog'
import useOperationReplace from './hooks/useOperationReplace'
import DialogAppInfo from 'pureComponents/DialogAppInfo'
import AlertTips from 'pureComponents/AlertTips'
import DialogPkgNameInput from '../../pureComponents/DialogPkgNameInput'
import DialogUploadTypeRadioGroup from '../../pureComponents/DialogUploadTypeRadioGroup'
import { ACCOUNT_TYPE } from '../OperationList/constants'
import Input from '@tencent/spaui-input'

const OperationAddDialog = props => {
    const { appInfo } = props
    const {
        handleSubmit,
        disableSubmit,
        setServiceProviderId,
        setAccount,
        submitInfo,
        setUid,
        reset,
        error,
    } = useOperationReplace(props)
    const onCancelClick = () => {
        props.onClose && props.onClose()
        reset()
    }

    return (
        <Dialog
            className="track-dialog"
            onSubmit={handleSubmit}
            title="换绑投放账户"
            style={{
                width: '500px',
            }}
            type="normal"
            submitLabel={disableSubmit ? '提交中...' : '确定'}
            disabled={disableSubmit}
            backdrop
            {...props}
            onClose={onCancelClick}
            onCancel={onCancelClick}
        >
            <div className="track-body-item">
                <DialogAppInfo label="APP名称：" name={appInfo.name || ''} desc={`（应用ID：${appInfo.openAppId}）`} />
            </div>
            {error ? (
                <div className="track-body-item">
                    <AlertTips type="error" icon="warn">
                        {error}
                    </AlertTips>
                </div>
            ) : null}
            <DialogUploadTypeRadioGroup
                data={[
                    { value: ACCOUNT_TYPE.SERVICE_PROVIDER, children: '服务商' },
                    { value: ACCOUNT_TYPE.DIRECT, children: '直客' },
                ]}
                label="投放帐户类型："
                vertical={true}
                value={submitInfo.selectAccount}
                onChange={val => setAccount(val)}
            />
            {submitInfo.showInput ? (
                <Input
                    type="number"
                    value={submitInfo.serviceProviderId}
                    placeholder="服务商id"
                    style={{ width: '180px' }}
                    onChange={(_, val) => setServiceProviderId(val)}
                ></Input>
            ) : (
                <></>
            )}
            <DialogPkgNameInput
                value={submitInfo.uid}
                onChange={setUid}
                label="新账户ID"
                placeholder="请输入新的账户ID"
            />
        </Dialog>
    )
}

export default OperationAddDialog
